import cn from 'clsx'
import {NavLink} from 'react-router-dom'

import useStore from 'base/store'
import styles from './DocumentsPanel.module.scss'
import {
  ShieldChekFourthIcon,
  DocumentPenIcon,
  CertificateMedalIcon,
  RotateArrowFifthIcon,
  FolderBookmarkIcon,
  ChatIcon,
  FolderIcon,
  SearchSecondIcon,
} from 'common/components'
import {DOCUMENTS_CATEGORY} from '..'

interface DocumentsPanelProps {
  isRequest?: boolean
  hasDrawdowns: boolean
}

interface LinkProps {
  link: LinkItem
}

interface LinkItem {
  label: string
  to: string
  icon: JSX.Element
  end?: boolean
  disabled?: boolean
  borrowerVisible?: boolean
}

export default function DocumentsPanel({
  isRequest,
  hasDrawdowns,
}: DocumentsPanelProps) {
  const role = useStore((state) => state.role)
  const isBorrower = (role?.user === true) && (role?.broker === false)
  const links: LinkItem[] = [
    {
      label: DOCUMENTS_CATEGORY.amlDocuments.label,
      to: '',
      icon: <ShieldChekFourthIcon />,
      end: true,
    },
    {
      label: DOCUMENTS_CATEGORY.proposal.label,
      to: DOCUMENTS_CATEGORY.proposal.key,
      icon: <DocumentPenIcon />,
    },
    {
      label: DOCUMENTS_CATEGORY.legal.label,
      to: DOCUMENTS_CATEGORY.legal.key,
      icon: <CertificateMedalIcon />,
      borrowerVisible: true,
    },
    {
      disabled: isRequest || !hasDrawdowns,
      label: DOCUMENTS_CATEGORY.drawdowns.label,
      to: DOCUMENTS_CATEGORY.drawdowns.key,
      icon: <RotateArrowFifthIcon />,
      borrowerVisible: true,
    },
    {
      label: DOCUMENTS_CATEGORY.project.label,
      to: DOCUMENTS_CATEGORY.project.key,
      icon: <FolderBookmarkIcon />,
      borrowerVisible: true,
    },
    {
      label: DOCUMENTS_CATEGORY.others.label,
      to: DOCUMENTS_CATEGORY.others.key,
      icon: <FolderIcon />,
    },
    {
      label: DOCUMENTS_CATEGORY.attachment.label,
      to: DOCUMENTS_CATEGORY.attachment.key,
      icon: <ChatIcon />,
    },
  ].filter(
    (x:LinkItem) => (
      (role?.user === false) ||
      (!!isBorrower && !!x.borrowerVisible)
    )
  )

  return (
    <div className={styles.root}>
      <ul className={styles.links}>
        {links.map((link) => (
          <li key={link.to}>
            <Link link={link} />
          </li>
        ))}
      </ul>
      { (role?.user === false) &&
        <Link link={searchLink} />
      }
    </div>
  )
}

const Link = ({link}: LinkProps) => {
  const isSearch = link.to === 'search'

  if (link.disabled)
    return (
      <div className={cn(styles.link, styles.link_disabled)}>
        {link.icon}
        {link.label}
      </div>
    )

  return (
    <NavLink
      className={({isActive}) =>
        cn(
          styles.link,
          isActive && styles.link_active,
          isSearch && styles.link_search
        )
      }
      to={link.disabled ? undefined : link.to}
      end={link.end}
    >
      {link.icon}
      {isSearch ? (
        <span className={styles.searchLabel}>
          <span>{link.label}</span>
        </span>
      ) : (
        link.label
      )}
    </NavLink>
  )
}

const searchLink: LinkItem = {
  label: 'Search',
  to: 'search',
  icon: <SearchSecondIcon />,
}
